import { useEffect, useState } from 'react';

const useIsInView = (target, options = {}, once = false) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [hasBeenIntersecting, setHasBeenIntersecting] = useState(false);
  const [observer, setObserver] = useState(null);

  useEffect(() => {
    const callback = (entries) => {
      if (target.current) {
        const intersecting = entries[0].isIntersecting;
        setIsIntersecting(intersecting);
        if (intersecting && once && !hasBeenIntersecting) {
          setHasBeenIntersecting(true);
          observer?.disconnect();
        }
      }
    };

    observer?.disconnect();

    if (target.current) {
      const _observer = new IntersectionObserver(callback, options);
      _observer.observe(target.current);
      setObserver(_observer);
    }

    return () => {
      observer?.disconnect();
    };
  }, [target]);

  return hasBeenIntersecting || isIntersecting;
};

export default useIsInView;
